<mat-card style="width: max-content; max-width: 100%;">
    <mat-card-header>
        <div class="g-just-flex flex-between w-100 flex-wrap gap-20">
            <div class="left">
               <mat-card-subtitle>
    Patient list
</mat-card-subtitle>
            </div>
            <div class="right gap-10 g-just-flex" style="flex-wrap: wrap;">
                <a mat-flat-button class="secondary-button small-button">
                    <mat-icon>file_upload</mat-icon> Import
                </a>
                @if (canExport$ | async) {
                <a mat-flat-button extended class="secondary-button small-button">
                    <mat-icon>file_download</mat-icon> Export
                </a>
                }
                @if (canAdd$ | async) {
                <a mat-flat-button routerLink="/app/patient-registration">
                    <mat-icon>add</mat-icon>
                    Add Patient
                </a>
                }
            </div>
        </div>
    </mat-card-header>

    <mat-card-content class="my-12">
        <mat-divider></mat-divider>
        @let patients = tableDataSource?.data ?? [];
        @let isLoading = (loading$ | async) ?? false;

        <app-table-header class="mt-15 mb-10" [patientsTableFilterArray]="patientsTableFilter"
            [patientsFiltersFormControlObject]="patientsFiltersFormControlObject"
            [hasData]="(patients.length > 0) || isLoading || !!searchTerm?.length || hasLoadedAnyRows"
            [showWhenSearching]="true" [searchableFields]="patientSearchFieldOptions"
            [selectedSearchField]="selectedSearchField" searchBoxTitle="Search patients"
            (filterChanged)="onFilterChanged($event)" (searchCriteriaChanged)="onSearchCriteriaChanged($event)">
        </app-table-header>

        <mat-divider></mat-divider>

        @if (error$ | async; as error) {
        <div class="error-text mt-16">{{ error }}</div>
        }

        @if (isLoading) {
        <div class="loading-container" style="text-align: center; padding: 20px;">
            <mat-icon style="animation: spin 1s linear infinite;">refresh</mat-icon>
            <p>Loading patients...</p>
        </div>
        }

        @if (!isLoading && patients.length > 0) {
        <table mat-table [dataSource]="tableDataSource" [trackBy]="trackByPatientId"
            class="mat-elevation-z8 demo-table">
            <!-- Name Column -->
            <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef>
                    Name
                </th>
                <td mat-cell *matCellDef="let element" [title]="element.name | patientName">
                    {{element.name | patientName}}
                </td>
            </ng-container>

            <!-- Hospital ID Column -->
             <ng-container matColumnDef="hospitalId">

                <th mat-header-cell *matHeaderCellDef>
                    Patient ID
                </th>
                
                <td mat-cell *matCellDef="let element" [title]="element.name | patientName">
                   
                            {{ getPatientHospitalId(element) }}
                       
                </td>
            </ng-container>

            <!-- Contacts Column -->
            <ng-container matColumnDef="phone">
                <th mat-header-cell *matHeaderCellDef>
                    Contacts
                </th>
                <td mat-cell *matCellDef="let element">
                    <div class="stacked-cell">
                        <div class="primary-line" [title]="element.telecom | patientContacts:'phone':1">
                            {{element.telecom | patientContacts:'phone':1}}
                        </div>
                        <div class="secondary-line" [title]="element.telecom | patientContacts:'email':1">
                            {{element.telecom | patientContacts:'email':1}}
                        </div>
                    </div>
                </td>
            </ng-container>

            <!-- Gender Column -->
            <ng-container matColumnDef="gender">
                <th mat-header-cell *matHeaderCellDef>
                    Gender
                </th>
                <td mat-cell *matCellDef="let element">{{element.gender | titlecase}}</td>
            </ng-container>

            <!-- Age Column -->
            <ng-container matColumnDef="age">
                <th mat-header-cell *matHeaderCellDef>
                    Age / DOB
                </th>
                <td mat-cell *matCellDef="let element">
                    <div class="stacked-cell">
                        <div class="primary-line" [title]="element.birthDate | patientAge:false">
                            {{element.birthDate | patientAge:false}}
                        </div>
                        <div class="secondary-line" [title]="element.birthDate | date:'MMM d, yyyy'">
                            {{element.birthDate | date:'MMM d, yyyy'}}
                        </div>
                    </div>
                </td>
            </ng-container>

            <!-- Address Column -->
            <ng-container matColumnDef="address">
                <th mat-header-cell *matHeaderCellDef>
                    Address
                </th>
                <td mat-cell *matCellDef="let element">{{element.address | patientAddress}}</td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="patientsTableDisplayedColumns"></tr>
            <tr mat-row (click)="showRow(row)" style="cursor: pointer;" title="Click to view patient records" *matRowDef="let row; columns: patientsTableDisplayedColumns;"></tr>
        </table>
        }

        @let total = (displayedTotal$ | async) ?? patients.length;
        @if (total > 0) {
        <mat-paginator class="mt-16" [length]="total" [pageSize]="pageSize" [pageIndex]="paginatorPageIndex"
            [pageSizeOptions]="[pageSize]" [hidePageSize]="true" showFirstLastButtons
            aria-label="Select page of patients" (page)="onPageChange($event)">
        </mat-paginator>
        }

        @if (unknownTotal$ | async) {
        <div class="caption subtitle-text-color-2 mt-6">Total count is unavailable; additional pages will load as the
            server provides link.next references.</div>
        }

        @if (!isLoading && patients.length === 0) {
        <app-empty-state class="py-40" [icon]="currentEmptyState.icon" [title]="currentEmptyState.title"
            [subtitle]="currentEmptyState.subtitle">
        </app-empty-state>
        }

    </mat-card-content>
</mat-card>
